import { TOOL_TIP_TEXT } from "@/constants/common.constants.js";

export const ADD_ONS_ANNUAL_COST = {
  he: () => {
    return new Date() > new Date("2024-01-30") ? 46.52 : 49.09;
  },
  le: () => {
    return 26.79;
  },
  rp: () => {
    return 26.79;
  },
  ad: () => {
    return 46.52;
  },
};

export const ADD_ONS_ANNUAL_COST_LANDLORDS = {
  he: () => {
    return 62.49;
  },
  le: () => {
    return 37.5;
  },
  leDiscounted: () => {
    return 33.75;
  },
  rp: () => {
    return 183.04;
  },
  rpDiscounted: () => {
    return 178.57;
  },
};

export const ADD_ONS_ANNUAL_COST_TENANT_CONTENTS = {
  le: () => {
    return 2.49;
  },
  ad: () => {
    return 4.59;
  },
};

export const ADD_ONS = [
  {
    type: "Home emergency cover",
    code: "he",
    tooltipText: TOOL_TIP_TEXT.HomeEmergency,
    dialogComponentName: "DialogContentHomeEmergency",
    dialogWidth: 800,
    image: "home-emergency.png",
    description: "Cover your home against sudden or unexpected events.",
    annualCost: ADD_ONS_ANNUAL_COST.he,
    isAdded: false,
  },
  {
    type: "Legal expenses cover",
    code: "le",
    tooltipText: TOOL_TIP_TEXT.LegalExpenses,
    dialogComponentName: "DialogContentLegalExpenses",
    dialogWidth: 800,
    image: "legal-expenses.png",
    description:
      "Get up to £100,000 per insured incident to pursue or defend your legal rights.",
    annualCost: ADD_ONS_ANNUAL_COST.le,
    isAdded: false,
  },
];

export const ADD_ONS_LANDLORDS = [
  {
    type: "Landlord's emergency cover",
    code: "he",
    tooltipText: TOOL_TIP_TEXT.HomeEmergency,
    image: "home-emergency.png",
    description: "Cover your property against any sudden or unexpected events.",
    annualCost: ADD_ONS_ANNUAL_COST_LANDLORDS.he,
    isAdded: false,
  },
  {
    type: "Legal expenses cover",
    code: "le",
    tooltipText: TOOL_TIP_TEXT.LegalExpenses,
    image: "legal-expenses.png",
    description:
      "Get up to £100,000 per insured incident to pursue or defend your legal rights.",
    annualCost: ADD_ONS_ANNUAL_COST_LANDLORDS.le,
    isAdded: false,
  },
  {
    type: "Rent protection cover",
    code: "rp",
    tooltipText: TOOL_TIP_TEXT.RentProtection,
    image: "rent-protection.png",
    description:
      "Get up to £2,500 per month to prevent a loss of income if your tenant stops paying the rent.",
    annualCost: ADD_ONS_ANNUAL_COST_LANDLORDS.rp,
    isAdded: false,
  },
];

export const ADD_ONS_LANDLORDS_D2C = [
  {
    type: "Landlord's emergency cover",
    dialogComponentName: "DialogLandLordsContentEmergency",
    code: "he",
    tooltipText: TOOL_TIP_TEXT.HomeEmergency,
    image: "home-emergency.png",
    description: "Cover your property against any sudden or unexpected events.",
    annualCost: ADD_ONS_ANNUAL_COST_LANDLORDS.he,
    isAdded: false,
    formControl: "landlordsEmergency",
  },
  {
    type: "Legal expenses cover",
    dialogComponentName: "DialogLandLordsContentLegalExpenses",
    code: "le",
    tooltipText: TOOL_TIP_TEXT.LegalExpenses,
    image: "legal-expenses.png",
    description:
      "Get up to £100,000 per insured incident to pursue or defend your legal rights.",
    annualCost: ADD_ONS_ANNUAL_COST_LANDLORDS.le,
    isAdded: false,
    formControl: "legalExpenses",
  },
  {
    type: "Rent protection cover",
    dialogComponentName: "DialogLandLordsRentProtection",
    code: "rp",
    tooltipText: TOOL_TIP_TEXT.RentProtection,
    image: "rent-protection.png",
    description:
      "Get up to £2,500 per month to prevent a loss of income if your tenant stops paying the rent.",
    annualCost: ADD_ONS_ANNUAL_COST_LANDLORDS.rp,
    isAdded: false,
    formControl: "rentGuarantee",
  },
];

export const ADD_ONS_TENANT_CONTENTS = [
  {
    type: "Would you like cover for legal expenses up to £100,000?",
    code: "le",
    tooltipText: TOOL_TIP_TEXT.LegalExpenses,
    dialogComponentName: "DialogTenantContentWhatsIncludedLegalExpenses",
    dialogWidth: 800,
    image: "legal-expenses.png",
    description:
      "You can add Tenants Legal Expenses. This will cover up to £100,000 for legal costs in pursuing and defending personal claims, such as tenancy disputes with the landlord, unlawful eviction, employment disputes and bodily injury claims.",
    annualCost: ADD_ONS_ANNUAL_COST_TENANT_CONTENTS.le,
    annualCostLabel: "per month",
    isAdded: false,
  },
  {
    type: "Would you like to upgrade your accidental damage cover?",
    code: "ad",
    image: "accidental-loss.png",
    tooltipText: "lorem ipsum dolor sit amet",
    dialogComponentName: "DialogTenantContentWhatsIncludedAccidentalDamage",
    dialogWidth: 800,
    description:
      "Accidental damage for TV’s, computer equipment and games consoles are included as standard; by upgrading we’ll also cover other unexpected damage which happens suddenly, such as spilling wine on your sofa or dropping your mobile phone in the bath.",
    annualCost: ADD_ONS_ANNUAL_COST_TENANT_CONTENTS.ad,
    hideAnnualCost: true,
    isAdded: false,
  },
];
